// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"4addef27","200":"c656ff9a","448":"2ab31234","535":"eab7e7ff","689":"d4a7226d","694":"4eebd8dc","784":"d38d4202","787":"b8161916"}[chunkId] + ".chunk.js";
};